import { createFileRoute } from "@tanstack/react-router";
import AdminDisputeDetailPage from "@/admin/pages/dispute-detail";

export const Route = createFileRoute("/admin/disputes/$id")({
  component: AdminDisputeDetailPage,
});
